import { Injectable, signal } from "@angular/core";
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";
import { IBreadcrumbItem } from "../model/breadcrumb.model";

@Injectable()
export class BreadcrumbDataService {
  private readonly _breadcrumb = signal<Partial<IBreadcrumbItem> | null>(null);

  readonly selectedBreadcrumb$ = toObservable(this._breadcrumb).pipe(
    filter((v): v is Partial<IBreadcrumbItem> => v !== null)
  );

  public setBreadcrumbItem(data: Partial<IBreadcrumbItem>) {
    this._breadcrumb.set(data);
  }

  public getCurrentBreadCrumbItem(): Observable<Partial<IBreadcrumbItem>> {
    return this.selectedBreadcrumb$;
  }
}
